import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './services/language.service';
import {AuthService} from './auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  showFooter: boolean = false;
  title = 'app';


  constructor(private translate: TranslateService,private languageService: LanguageService
    ,private authService: AuthService
  ) {
    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('fr');

    const browserLang = localStorage.getItem('lang') || translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');

    this.languageService.initLanguage();
  }

  ngOnInit() {
    this.authService.handleRedirect();
    this.languageService.initLanguage(); // Ensures language persists on refresh and after login
  }
}
